import React from "react";
import { Link } from "react-router-dom";
import { useLocale } from "../i18n";
import SEO from "../components/SEO";
import { Compass, MessagesSquare, Route, ArrowUpRight } from "lucide-react";

export default function NotFound() {
  const { locale } = useLocale();
  const en = locale === "en";

  return (
    <>
      <SEO
        title={en ? "Page not found" : "Pagina nu a fost găsită"}
        description={en
          ? "This page doesn't exist. Here are a few places worth heading instead."
          : "Această pagină nu există. Câteva locuri unde poți să mergi în schimb."}
        path="/404"
        noindex
      />
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-24 lg:py-32" data-testid="not-found-page">
        <p className="font-mono-wr text-[11px] uppercase tracking-[0.3em] text-[var(--wr-red)] mb-4">
          / 404 · {en ? "PAGE NOT FOUND" : "PAGINA NU A FOST GĂSITĂ"}
        </p>
        <h1 className="font-editorial text-[80px] sm:text-[120px] lg:text-[180px] leading-[0.9] tracking-tight text-[var(--wr-ink)] mb-8" data-testid="not-found-title">
          {en ? "Off the map." : "În afara hărții."}
        </h1>
        <p className="text-[18px] sm:text-[20px] leading-relaxed text-[var(--wr-ink-2)] max-w-xl mb-16">
          {en
            ? "This page doesn't exist — or has moved. Here are a few places worth heading instead."
            : "Această pagină nu există — sau s-a mutat. Câteva locuri unde merită să mergi în schimb."}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl">
          <Link to="/" className="wr-sharp-card p-6 group flex flex-col justify-between min-h-[160px] hover:-translate-y-1 transition-transform" data-testid="nf-home">
            <div className="flex items-start justify-between">
              <ArrowUpRight size={18} className="text-[var(--wr-red)]" />
            </div>
            <div>
              <h3 className="font-editorial text-2xl leading-none tracking-tight text-[var(--wr-ink)] mb-1">{en ? "Home" : "Acasă"}</h3>
              <p className="text-[13px] text-[var(--wr-ink-2)] leading-snug">{en ? "Start from the beginning." : "Începe de la început."}</p>
            </div>
          </Link>
          <Link to="/regions" className="wr-sharp-card p-6 group flex flex-col justify-between min-h-[160px] hover:-translate-y-1 transition-transform" data-testid="nf-regions">
            <div className="flex items-start justify-between">
              <Compass size={18} className="text-[var(--wr-red)]" />
            </div>
            <div>
              <h3 className="font-editorial text-2xl leading-none tracking-tight text-[var(--wr-ink)] mb-1">{en ? "Destinations" : "Destinații"}</h3>
              <p className="text-[13px] text-[var(--wr-ink-2)] leading-snug">{en ? "Nine cultural regions." : "Nouă regiuni culturale."}</p>
            </div>
          </Link>
          <Link to="/tools" className="wr-sharp-card p-6 group flex flex-col justify-between min-h-[160px] hover:-translate-y-1 transition-transform" data-testid="nf-tools">
            <div className="flex items-start justify-between">
              <Route size={18} className="text-[var(--wr-red)]" />
            </div>
            <div>
              <h3 className="font-editorial text-2xl leading-none tracking-tight text-[var(--wr-ink)] mb-1">Tools</h3>
              <p className="text-[13px] text-[var(--wr-ink-2)] leading-snug">{en ? "Five utilities that work." : "Cinci utilitare care funcționează."}</p>
            </div>
          </Link>
          <Link to="/concierge" className="wr-sharp-card p-6 group flex flex-col justify-between min-h-[160px] hover:-translate-y-1 transition-transform" data-testid="nf-concierge">
            <div className="flex items-start justify-between">
              <MessagesSquare size={18} className="text-[var(--wr-red)]" />
            </div>
            <div>
              <h3 className="font-editorial text-2xl leading-none tracking-tight text-[var(--wr-ink)] mb-1">{en ? "AI Concierge" : "Ghid AI"}</h3>
              <p className="text-[13px] text-[var(--wr-ink-2)] leading-snug">{en ? "Ask anything about Romania." : "Întreabă orice despre România."}</p>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}
